module.exports = __webpack_public_path__ + "img/edge_patrimoine_geologie.2bdaa6da.svg";